define('components/sectors',[
    'jquery',
    'components/decorator'
], function($, decorator) {

    $.extend(companyInfo.handlers, {


        'add-sectors': function(e) {
            if (!$(this).siblings('ul').length) {
                $(this).parent().attr({'data-decorator': 'sectors-list', 'data-sector-id': this.getAttribute('data-sector-id')});
                decorator.run($(this).parent().parent());
            }
        },

        'toggle-sector': function(e) {
            $(this).parent().toggleClass('on');
            if (companyInfo.ie) {
                $(this).closest('.panel').removeClass('ie8fix').addClass('ie8fix');
            }
        }

    });

    $.extend(companyInfo.decorators, {

        'sectors-selector': function() {
            //overwrite the select2 clearSearch in prototype, to make sure
            //that the searchterm will stay when you remove focus from the box
            window.Select2.class.multi.prototype.clearSearch=function(){
                var placeholder = this.getPlaceholder(),
                    maxWidth = this.getMaxSearchWidth();
               // CurrentThisInput=(this.search); i used this to get the current select2 element and make further action if required.
                if(this.search.val()!==""){}else
                if (placeholder !== undefined  && this.getVal().length === 0 &&  this.search.val()==="") {
                    this.search.val(placeholder).addClass("select2-default");
                    this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
                }
            };




            var expandedResults;

            if (!companyInfo.sectors || !companyInfo.sectors.length) {
                return;
            }

            var sectors = [];
            var neededSectorIds = $(this).attr('data-needed-sectors') && $(this).attr('data-needed-sectors').split(',');
            var hideSbiCode = $(this).data('hide-sbi-code');
            var addedCategories = [];


            if (neededSectorIds && neededSectorIds.length > 0) {
                companyInfo.sectors.forEach(function (sector) {
                    if ($.inArray(sector.id, neededSectorIds) > -1) {
                        if ($.inArray(sector.c.charAt(0), addedCategories) === -1) {
                            var categories = companyInfo.sectors.filter(function(sec) {
                                return sec.c === sector.c.charAt(0);
                            });
                            sectors.push(categories[0]);
                            addedCategories.push(categories[0].c);
                        }
                        sectors.push(sector);
                    }
                });
            } else {
                sectors = companyInfo.sectors;
            }

            var data = [], i, len, sector, group, selected = [];
            if (companyInfo.ie) {
                // TODO: see if IE8 is performant enough (not really, trying with sector ID's with lenghts smaller than 5)
                for (i = 0, len = sectors.length; i < len; i++) {
                    sector = sectors[i];
                    if (!sector.id || sector.id.length > 4) {
                        continue;
                    }
                    data.push({
                        id: sector.id,
                        css: 'l' + sector.l,
                        text: sector[companyInfo.lang] + ' (' + sector.id + ')'
                    });
                }
            } else {
                for (i = 0, len = sectors.length; i < len; i++) {
                    sector = sectors[i];
                    if (!sector.id) {
                        if (group) {
                            data.push(group);
                        }
                        group = {
                            text: sector[companyInfo.lang] + ' (' + sector.c + ')',
                            children: []
                        };
                        continue;
                    }
                    group.children.push({
                        id: sector.id,
                        css: 'l' + sector.l,
                        text: sector[companyInfo.lang] + ' (' + sector.id + ')'
                    });
                }
            }

            companyInfo.emptySearch = true;
            $(this).select2({
                placeholder: '',
                dropdownCssClass: 'sector-selector',
                openOnEnter: false,
                //closeOnSelect: false, //CI-7336: no longer closes on select
                hideSBICode: this.getAttribute("data-hide-sbi-code"),
                maximumSelectionSize: this.getAttribute('data-max') ? this.getAttribute('data-max') : 0,
                data: data,
                multiple: true,
                adaptContainerCssClass: function(str) {
                    return str.replace('input', '');
                },
                sortResults: function (results, container, query) {
                    companyInfo.emptySearch = (query.term === '');
                    return results;
                },
                formatResultCssClass: function(result) {
                    var wasExpanded = false;
                    if (!result.id) {
                      wasExpanded = $.inArray(result.text, expandedResults) > -1;
                    }
                    return (companyInfo.emptySearch && !wasExpanded ? 'empty-search ' : '') + result.css;
                },
                nextSearchTerm: function(selectedObject, currentSearchTerm) {
                    return currentSearchTerm;
                },
                clearSearch: function() {
                    return;
                },
                formatSelection: function(data, container){
                  var text = data.text;
                  text= this.hideSBICodeHTML(text, this.hideSBICode);
                  return text;
                },
                hideSBICodeHTML: function (txt, hideSbiCode) {
                    var str = txt;
                    if(hideSbiCode){
                        str = txt.replace(/(\(\d*\))|(\(\w{1}\))/, '<span class="select2-result-hide">$1$2</span>');
                    }

                    return unescape(str);
                },
                formatResult: function(result, label, query, escapeMarkup) {
                    var markup = [];
                    //result.text = this.hideSBICode(result.text);
                    Select2.util.markMatch(result.text, query.term, markup, escapeMarkup);
                    var text = markup.join('');
                    text= this.hideSBICodeHTML(text, this.hideSBICode);

                    if(result.children && companyInfo.emptySearch){
                      return '<button class="inline-button" onclick="$(this).parent().parent().toggleClass(\'empty-search\');"><i class="ico ico-plus"></i><div class="select2-results-text">' + text + '</div></button>';
                    }else{
                      return text;
                    }

                },
                escapeMarkup: function(m) {
                    return m;
                }
            });

            $(this).on("select2-selecting", function (e) {
                expandedResults = [];
                $("#select2-drop .select2-results > .select2-result:not(.empty-search) > .select2-result-label").each(function(){ expandedResults.push(this.textContent); });
            });
            $("#select2-drop").select2("close");
        },

        'sectors-list': function() {
            if (!companyInfo.sectors || !companyInfo.sectors.length) {
                return;
            }
            var parent = this.getAttribute('data-sector-id') || '';
            var list = this.getAttribute('data-sectors') || false;
            var nested = this.getAttribute('data-nested') || false;
            var nodes = [];
            if (parent === '' && companyInfo.sbi) {
                list = companyInfo.sbi.c.substring(0, 1);
            }
            if (list) {
                nodes = companyInfo.sectors.filter(function(sector) {
                    return sector.p === '' && list.indexOf(sector.c) !== -1;
                });
            } else {
                nodes = companyInfo.sectors.filter(function(sector) {
                    return sector.p === parent;
                });
            }
            nodes = nodes.map(function(sector) {
                if (sector.c != 'Z') {
                    return '<li' + (nested && companyInfo.sbi && companyInfo.sbi.c.indexOf(sector.c) !== -1 ? ' class="on" data-decorator="sectors-list" data-nested="true" data-sector-id="' + sector.c + '"' : '') + '>' + (sector.k ? '<button type="button" class="inline-button" data-handler="add-sectors toggle-sector toggle-icon" data-toggle-icon="ico ico-single ico-minus" data-sector-id="' + sector.c + '"><i class="ico ico-single ico-plus"></i></button> ' : '') + '<a href="/sbi/' + sector.c + '"' + (companyInfo.sbi && companyInfo.sbi.c == sector.c ? ' class="selected"' : '') + '>' + sector[companyInfo.lang] + '</a></li>';
                }
            });
            if (nodes.length) {
                $(this).append('<ul>' + nodes.join('') + '</ul>');
                if (nested) {
                    decorator.run(this);
                }
            }
        }

    });

});

